const calloutComponentInputCheckboxValidator = (_schema, answer) => {
  return typeof answer === "boolean";
};
export {
  calloutComponentInputCheckboxValidator
};
